import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Table } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchAndroidAnalyticsRequest } from "../../store/Dashboard/dashboardAction";
import { SpakChart1 } from './ChartComponet/AndroidDeviceChart';

const AndroidDeviceData = ({ socket }) => {
    const [data, setData] = useState("")

    const dispatch = useDispatch();
    const { data: androidUserAnalytics, loading, error } = useSelector(
        (state) => state.androidUserAnalytics
    );

    useEffect(() => {
        dispatch(fetchAndroidAnalyticsRequest());
    }, [dispatch]);

    useEffect(() => {
        if (androidUserAnalytics !== undefined) {
            setData(androidUserAnalytics)
        }
    }, [androidUserAnalytics]);

    return (
        <React.Fragment>
            <Col lg={4}>
                <Card>
                    <CardBody>
                        <h4 className="card-title mb-3">Android Users Analytics</h4>
                        <div>
                            <div className="text-center border rounded py-4">
                                <p className="mb-2">Total Devices</p>
                                <h4>{data.total}</h4>
                                <div className="text-success">
                                    <i className="mdi mdi-menu-up font-size-14"> </i>2.2 %
                                </div>
                            </div>


                            <div className="table-responsive mt-4">
                                <Table hover className=" mb-0 table-centered table-nowrap">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h5 className="font-size-14 mb-0">Expire Devices</h5>
                                            </td>
                                            <td>
                                                <div id="spak-chart2">
                                                    <SpakChart1 color={'#b7262b'} />
                                                </div>
                                            </td>
                                            <td>
                                                <p className="text-muted mb-0">{data.expireDevices}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <h5 className="font-size-14 mb-0">Active Devices</h5>
                                            </td>
                                            <td>
                                                <div id="spak-chart1">
                                                    <SpakChart1 color={'#3ec59d'} />
                                                </div>
                                            </td>
                                            <td>
                                                <p className="text-muted mb-0">{data.active}</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <h5 className="font-size-14 mb-0">Paid Devices</h5>
                                            </td>
                                            <td>
                                                <div id="spak-chart1">
                                                    <SpakChart1 color={'#0D47A1'} />
                                                </div>
                                            </td>
                                            <td>
                                                <p className="text-muted mb-0">{data.paidUser}</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default AndroidDeviceData;
